import Login from '@/services/auth/authService/Login';
import Logout from '@/services/auth/authService/Logout';
import Refresh from '@/services/auth/authService/Refresh';
import CanvasserLogin from '@/services/auth/authService/CanvasserLogin';
import CanvasserRefresh from '@/services/auth/authService/CanvasserRefresh';

export default class AuthService {
    /**
     * Log in by getting the access token.
     *
     * @param {String} email
     * @param {String} password
     *
     * @returns {Promise}
     */
    login(email, password) {
        return (new Login()).handle(email, password);
    }

    /**
     * Canvasser log in by getting the access token.
     *
     * @param {String} email
     * @param {String} password
     *
     * @returns {Promise}
     */
    canvasserLogin(email, password) {
        return (new CanvasserLogin()).handle(email, password);
    }

    /**
     * Log the user out.
     *
     * @returns {Promise}
     */
    logout() {
        return (new Logout()).handle();
    }

    /**
     * Log the user out from the frontend website.
     *
     * @returns {void}
     */
    static frontendLogout() {
        return (new Logout()).frontendLogout();
    }

    /**
     * Refresh an access token using a refresh token.
     *
     * @returns {Promise}
     */
    refresh() {
        return (new Refresh()).handle();
    }

    /**
     * Refresh the canvasser's access token using a refresh token.
     *
     * @returns {Promise}
     */
    refreshCanvasser() {
        return (new CanvasserRefresh()).handle();
    }
}
